import { Card } from "../../../../../../components/Card";
import { Accordion, Grid, GridItem, Heading } from "@chakra-ui/react";
import { IconTitle } from "../../../../../../components/IconTitle";
import NumberField from "../../../../../../components/NumberField/NumberField";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { MissingDataLabel } from "../../../../components/MissingDataLabel";
import { TotalReportGridAccordionItem, V2BreakdownAccordionItem } from "./index";
import ManualEmissionsList from "../../shared/ManualEmissionsList";

function ScopeSection({ title, data, manualEmissions, totalEntity }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });

  const hasActivityItems = data && Object.keys(data).length > 0 &&
    Object.keys(data).some(key => data[key]?.items?.length > 0);
  const manualRows = manualEmissions ?? [];
  const hasManualEmissions = manualRows.length > 0;

  return (
    <Card boxShadow="xs">
      <Heading size="md" marginBlock="1">
        {title}
      </Heading>

      <Accordion
        defaultIndex={[0]} allowMultiple marginTop="10"
        marginBottom={totalEntity && totalEntity.value > 0 ? "10" : "0"}
      >
        {Object.keys(data).map(emissionsKey => {
          // ESG-3927: the v2 breakdown has its own row shape (no org-structure
          // consumption types / per-measure rows) — render it via a dedicated
          // item, not the v1 accordion item.
          if (emissionsKey === "electricityV2") {
            return data.electricityV2?.items?.length > 0 ?
              <V2BreakdownAccordionItem key="accordion-item-electricityV2" items={data.electricityV2.items} /> : null;
          }
          return data[emissionsKey]?.items?.length > 0 ?
            <TotalReportGridAccordionItem
              key={`accordion-item-${emissionsKey}`}
              data={data}
              title={t(`${emissionsKey}Title`)}
              type={emissionsKey}
            /> : null;
        })}
      </Accordion>

      <ManualEmissionsList items={manualRows} />

      {totalEntity && totalEntity.value > 0 && <Grid templateColumns="repeat(2, 1fr)" gap={2} overflow="auto" marginTop="6">
        <GridItem>
          <IconTitle
            icon={undefined}
            title={totalEntity.title}
            subTitle={totalEntity.subTitle}
          />
        </GridItem>
        <GridItem>
          <NumberField fontWeight="bold" value={totalEntity.value} />
        </GridItem>
      </Grid>}

      {!hasActivityItems && !hasManualEmissions && <MissingDataLabel />}
    </Card>
  );
}

export default ScopeSection;